import { createContext, useContext, useMemo } from "react";

const ViewConfigContext = createContext(null);

export function ViewConfigProvider({ viewConfig, calendarSet, children }) {
  const value = useMemo(
    () => ({ viewConfig, calendarSet }),
    [viewConfig, calendarSet?.id]
  );

  return (
    <ViewConfigContext.Provider value={value}>
      {children}
    </ViewConfigContext.Provider>
  );
}

export function useViewConfig() {
  const value = useContext(ViewConfigContext);
  if (!value) {
    throw new Error("useViewConfig must be used within a ViewConfigProvider");
  }
  return value;
}
